import { h } from 'preact';

import { GlobalState } from '../states/global-state';
import { useEffect } from 'preact/hooks';
import { showAlert } from '../utils';

const Network = () => {
  const offlineHandler = e => {
    console.log('no network');

    showAlert({
      title: 'Network Error',
      icon: 'error',
      text: 'The network connection has been lost, waiting connection to resume',
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  };

  const onlineHandler = e => {
    showAlert({
      title: 'Network Recovered',
      icon: 'success',
      text: 'The network connection has been recovered',
      allowOutsideClick: false,
      showConfirmButton: true,
    });
  };

  useEffect(() => {
    window.addEventListener('online', onlineHandler);
    window.addEventListener('offline', offlineHandler);

    return () => {
      window.removeEventListener('online', onlineHandler);
      window.removeEventListener('offline', offlineHandler);
    };
  }, []);
  return <div class="d-none network" />;
};

export default Network;
